import FLASH from '../types/flash'

const state = {
  isVisible: false,
  title: '',
  subtitle: '',
  type: '',
  link: '',
  showCloseButton: false,
  hexColors: {},
  icon: {},
  shouldAutoClose: false,
  isFixed: false,
  imageUrl: '',
  duration: null,
  contentAlignment: ''
}

const getters = {
  [FLASH.GETTERS.GET_IS_VISIBLE]: state => {
    return state.isVisible
  },
  [FLASH.GETTERS.GET_TITLE]: state => {
    return state.title
  },
  [FLASH.GETTERS.GET_SUBTITLE]: state => {
    return state.subtitle
  },
  [FLASH.GETTERS.GET_TYPE]: state => {
    return state.type
  },
  [FLASH.GETTERS.GET_LINK]: state => {
    return state.link
  },
  [FLASH.GETTERS.GET_SHOW_CLOSE_BUTTON]: state => {
    return state.showCloseButton
  },
  [FLASH.GETTERS.GET_HEX_COLORS]: state => {
    return state.hexColors
  },
  [FLASH.GETTERS.GET_ICON]: state => {
    return state.icon
  },
  [FLASH.GETTERS.GET_SHOULD_AUTO_CLOSE]: state => {
    return state.shouldAutoClose
  },
  [FLASH.GETTERS.GET_IS_FIXED]: state => {
    return state.isFixed
  },
  [FLASH.GETTERS.GET_IMAGE_URL]: state => {
    return state.imageUrl
  },
  [FLASH.GETTERS.GET_DURATION]: state => {
    return state.duration
  },
  [FLASH.GETTERS.GET_CONTENT_ALIGNMENT]: state => {
    return state.contentAlignment
  }
}

const mutations = {
  [FLASH.MUTATIONS.SET_FLASH]: (state, payload) => {
    state.isVisible = !!payload.title
    state.title = payload.title
    state.subtitle = payload.subtitle
    state.type = payload.type || 'default'
    state.link = payload.link
    state.showCloseButton = payload.showCloseButton
    state.hexColors = payload.hexColors || {}
    state.icon = payload.icon || {}
    state.shouldAutoClose = !!payload.shouldAutoClose
    state.isFixed = !!payload.isFixed
    state.imageUrl = payload.imageUrl
    state.duration = payload.duration
    state.contentAlignment = payload.contentAlignment || ''
  },
  [FLASH.MUTATIONS.SET_IS_VISIBLE]: (state, payload) => {
    state.isVisible = !!payload
    state.shouldAutoClose = false
  }
}

export default {
  state,
  getters,
  mutations
}
